export const CREATE_CUSTOMERS_LOCATION_REQUEST = 'CREATE_CUSTOMERS_LOCATION_REQUEST';
export const CREATE_CUSTOMERS_LOCATION_SUCCESS = 'CREATE_CUSTOMERS_LOCATION_SUCCESS';
export const CREATE_CUSTOMERS_LOCATION_FAILURE = 'CREATE_CUSTOMERS_LOCATION_FAILURE';
